export const GET_BATCHITEMS = 'GET_BATCHITEMS';
export const GET_BATCHITEMS_SUCCESS = 'GET_BATCHITEMS_SUCCESS';
export const GET_BATCHITEMS_FAILED = 'GET_BATCHITEMS_FAILED';



export const UPDATE_BATCHITEMS = 'UPDATE_BATCHITEMS';
export const UPDATE_BATCHITEMS_SUCCESS = 'UPDATE_BATCHITEMS_SUCCESS';
export const UPDATE_BATCHITEMS_FAILED = 'UPDATE_BATCHITEMS_FAILED';



export const CREATE_BATCHITEMS = 'CREATE_BATCHITEMS';
export const CREATE_BATCHITEMS_SUCCESS = 'CREATE_BATCHITEMS_SUCCESS';
export const CREATE_BATCHITEMS_FAILED = 'CREATE_BATCHITEMS_FAILED';

export const CREATE_SELECT_BATCHITEMS = 'CREATE_SELECT_BATCHITEMS';
export const CREATE_SELECT_BATCHITEMS_SUCCESS = 'CREATE_SELECT_BATCHITEMS_SUCCESS';
export const CREATE_SELECT_BATCHITEMS_FAILED = 'CREATE_SELECT_BATCHITEMS_FAILED';